export default __webpack_public_path__ + "static/media/hht1_ep15_timeline_q02_a.5b9304f6.png";